import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import EntriesList from '../../shared/entries/EntriesList';
import Switcher from '../../shared/Switcher';
import fixMobileSafariWhiteScreenBug from '../../utils/fixMobileSafariWhiteScreenBug';

const switcherTitles = ['Big Races', 'Flat', 'Jumps'];
const switcherKeys = ['progenyEntriesBigRaces', 'progenyEntriesFlat', 'progenyEntriesJumps'];

const getInitRaceTypeNumber = (data) => {
    for (const idx in switcherKeys) { // eslint-disable-line no-restricted-syntax
        if (!isEmpty(data[switcherKeys[idx]].data.progenyEntries)) {
            return +idx;
        }
    }
    return 0;
};

class ProgenyEntries extends PureComponent {
    constructor(props) {
        super(props);

        const { sireStatus } = props.data.profile;
        this.state = { raceType: sireStatus && getInitRaceTypeNumber(props.data) };
    }

    setSelected = (raceType) => {
        this.setState({ raceType }, () => {
            fixMobileSafariWhiteScreenBug();
        });
    }

    render() {
        const { data } = this.props;
        const { sireStatus } = data.profile;
        const entries = (sireStatus
            ? data[switcherKeys[this.state.raceType]].data.progenyEntries
            : data.progenyEntries) || [];
        const noDataText = `No progeny entries${sireStatus ? ' for this stallion' : ''}`;

        return (
            <div className="hp-progenyEntries">
                { sireStatus && <div className="ui-centered-wrapper">
                    <Switcher
                        items={switcherTitles}
                        selected={this.state.raceType}
                        setSelected={this.setSelected}
                    />
                </div>}
                <EntriesList
                    entries={entries}
                    noDataText={noDataText}
                    isHorseShown
                    isDamShown={sireStatus}
                    showMore={this.showMore}
                    shownItems={this.state.shownItems}
                />
            </div>
        );
    }
}

const progenyEntriesTypes = PropTypes.arrayOf(PropTypes.shape({
    courseStyleName: PropTypes.string,
    courseUid: PropTypes.number,
    damCountryCode: PropTypes.string,
    damName: PropTypes.string,
    damUid: PropTypes.number,
    horseAge: PropTypes.number,
    horseCountryCode: PropTypes.string,
    horseName: PropTypes.string,
    horseUid: PropTypes.number,
    raceDatetime: PropTypes.string,
    raceInstanceTitle: PropTypes.string,
    raceInstanceUid: PropTypes.number,
    raceStatusCode: PropTypes.string,
    raceUid: PropTypes.number,
}));
const stallionProgenyEntriesTypes = PropTypes.shape({
    data: PropTypes.shape({ progenyEntries: progenyEntriesTypes }),
});

ProgenyEntries.propTypes = {
    data: PropTypes.shape({
        profile: PropTypes.shape({
            sireStatus: PropTypes.bool,
        }),
        progenyEntries: progenyEntriesTypes,
        progenyEntriesBigRaces: stallionProgenyEntriesTypes,
        progenyEntriesFlat: stallionProgenyEntriesTypes,
        progenyEntriesJumps: stallionProgenyEntriesTypes,
    }).isRequired,
};

export default ProgenyEntries;



// WEBPACK FOOTER //
// ./src/js/horse/progenyEntries/ProgenyEntries.jsx